(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('my-domain-notification', {
                parent: 'alerting',
                url: '/my-domain-notification?search&page&sort',
                data: {
                    authorities: [],
                    pageTitle: 'jotApp.myDomainNotification.dashboard.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/my-domain-notification/my-domain-notification.html',
                        controller: 'MyDomainNotificationController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: [],
                        squash: true
                    },
                    search: {
                        value: '',
                        squash: true
                    },
                    itemsPerPageChosen: null,
                    predicates: {}
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            filter: $stateParams.filter,
                            search: $stateParams.search,
                            predicates: $stateParams.predicates,
                            name: $stateParams.name,
                            fleet: $stateParams.fleet,
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('myDomainNotification');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    domain: ['TabDomains', function (TabDomains) {
                        return TabDomains.current();
                    }]
                }
            })
            .state('my-domain-notification-view', {
                parent: 'my-domain-notification',
                url: '/my-domain-notification/{id}',
                data: {
                    authorities: [],
                    pageTitle: 'jotApp.myDomainNotification.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/my-domain-notification/my-domain-notification-detail.html',
                        controller: 'MyDomainNotificationDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', function ($translate) {
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'MyDomainNotification', function ($stateParams, MyDomainNotification) {
                        return MyDomainNotification.getOne({id: $stateParams.id});
                    }]
                }
            })
            .state('my-domain-notification-new', {
                parent: 'my-domain-notification',
                url: '/my-domain-notification',
                data: {
                    authorities: [],
                    pageTitle: 'jotApp.myDomainNotification.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/my-domain-notification/my-domain-notification-dialog.html',
                        controller: 'MyDomainNotificationDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', function ($translate) {
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            id: null,
                            name: null,
                            active: true,
                            frequency: null,
                            userProfile: null,
                            wipStatus: "all",
                            objectsStatus: "all",
                            status: "all",
                            fleets: [],
                            categories: [],
                            warningNames: [],
                            cron: "0 0 * * *",
                            nextExecutionDatetime: null,
                            myDomainNotificationAlertConfigurations : []
                        };
                    }
                }
            })
            .state('my-domain-notification-edit', {
                parent: 'my-domain-notification',
                url: '/my-domain-notification/{id}/edit',
                data: {
                    authorities: [],
                    pageTitle: 'jotApp.myDomainNotification.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/my-domain-notification/my-domain-notification-dialog.html',
                        controller: 'MyDomainNotificationDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', function ($translate) {
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'MyDomainNotification', function ($stateParams, MyDomainNotification) {
                        return MyDomainNotification.getOne({id: $stateParams.id});
                    }]
                }
            })
            .state('my-domain-notification-clone', {
                parent: 'my-domain-notification',
                url: '/my-domain-notification/{id}/clone',
                data: {
                    authorities: [],
                    pageTitle: 'jotApp.myDomainNotification.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/my-domain-notification/my-domain-notification-dialog.html',
                        controller: 'MyDomainNotificationDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', function ($translate) {
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'MyDomainNotification', function ($stateParams, MyDomainNotification) {
                        return MyDomainNotification.getClone({id: $stateParams.id}).$promise
                    }]
                }
            })
    }
})();
